import * as React from "react";
import "../style/history.css";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { useEffect, useState } from "react";

import { api } from "../api";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

/**
 * Recent finished rounds, three win/lose pips per row (one per frame).
 * Reads the authenticated `/api/teenpatti/history` endpoint — the source hit
 * an unauthenticated `gameHistory/result` route on a different backend.
 */
const History = (props) => {
  const { dialog, setDialog } = props;

  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setDialog(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .getHistory(30)
      .then((res) => {
        if (cancelled) return;
        setRounds((res && res.rounds) || []);
      })
      .catch((error) => {
        console.error(error);
        if (!cancelled) setRounds([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return (
    <Dialog
      fullScreen
      open={dialog}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }} className="bg-white border-bottom sticky-top">
        <Toolbar>
          <Typography sx={{ ml: 1, flex: 1 }} variant="h6" component="div" className="text-dark">
            <span>{"< "}</span>
            History
          </Typography>
          <Button autoFocus color="inherit" onClick={handleClose} className="fw-bold">
            Close
          </Button>
        </Toolbar>
      </AppBar>
      <div>
        <div className="row sticky-topFrame">
          <div className="col-4">
            <h2 className="text-center historyFont" style={{ color: "#ff7a00" }}>A</h2>
          </div>
          <div className="col-4" style={{ color: "#ffa800" }}>
            <h2 className="text-center historyFont">B</h2>
          </div>
          <div className="col-4">
            <h2 className="text-center historyFont" style={{ color: "#eec800" }}>C</h2>
          </div>
        </div>
        <div className="mt-5">
          {loading ? (
            <div className="col-sm-6 text-center">
              <div className="loader1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ animationDelay: `${i * 0.1}s` }} />
                ))}
              </div>
            </div>
          ) : rounds.length > 0 ? (
            rounds.map((r) => (
              <div key={r._id} className="row">
                {[1, 2, 3].map((frameId) => (
                  <div
                    key={frameId}
                    className="col-4 d-flex justify-content-center align-items-center"
                  >
                    <p
                      className={`${
                        r.winningFrameId === frameId ? "bg-danger" : "failButton"
                      } border rounded-circle winCircle`}
                    >
                      {r.winningFrameId === frameId ? "Win" : "Lose"}
                    </p>
                  </div>
                ))}
              </div>
            ))
          ) : (
            <p className="mt-no-1">No Data Found !!</p>
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default History;
